import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    email: yup.string().required('Campo obbligatorio').min(3, 'Username non valido'),
    password: yup.string().required('Campo obbligatorio').min(3, 'Password non valida'),
  });
